export default __webpack_public_path__ + "static/media/mShorts_1_p3.9b30abe3.jpeg";